/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Items_AuditedInputs */

const en_audit_items_audited = /** @type {(inputs: Audit_Items_AuditedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items Audited`)
};

const es_audit_items_audited = /** @type {(inputs: Audit_Items_AuditedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articulos Auditados`)
};

/**
* | output |
* | --- |
* | "Items Audited" |
*
* @param {Audit_Items_AuditedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_items_audited = /** @type {((inputs?: Audit_Items_AuditedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Items_AuditedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_items_audited(inputs)
	return es_audit_items_audited(inputs)
});